import {startOrbit} from './launcher/orbit-starter';
import {startLauncher} from './launcher/launcher-starter';
import React from "react";
import ReactDOM from 'react-dom';
import InsideOrbitMenuComponent from "./launcher/components/inside-orbit-menu/inside-orbit-menu.component";
import {InsideOrbitMenuService} from "./launcher/services/inside-orbit-menu-services/inside-orbit-menu.service";
import {IInsideOrbitMenuServices} from "./launcher/services/inside-orbit-menu-services/inside-orbit-menu.service.interface";
import {ThemeProvider} from '@material-ui/core';
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import {isLauncherPath} from "./launcher/utils/launcher-constants/launcher-constants";
import LauncherToOrbitProxyService from './launcher/services/inside-orbit-menu-services/launcher-to-orbit-proxy/launcher-to-orbit-proxy.service';
import {LocationService} from "./app-react/services/location/location.service";
import {ConsoleLoggerService} from './app-react/services/logger/console-logger.service';
import {StorageService} from './app-react/services/storage/storage.service';
import {INSIDE_ORBIT_MENU_CONTAINER} from "./app-react/components/inside-orbit-menu-container/inside-orbit-menu-container.consts";

window['isQAModeEnabled'] = true;


/**
 * This is the launcher index file.
 * We need to keep the index.tsx name because the react scripts generated by the create-react-app has this name hardcoded inside.
 */

const renderInsideOrbitMenu = (shouldRenderInsideOrbitMenuPeriodicCheck) => {

    const theme = createMuiTheme({
        palette: {
            primary: { main: '#ff0000' }
        }
    });

    const launcherToOrbitProxyService = new LauncherToOrbitProxyService();

    const isMobileNotTablet = launcherToOrbitProxyService.isMobileNotTablet();

    const container = document.getElementById(INSIDE_ORBIT_MENU_CONTAINER);

    if (container) {

        const insideOrbitMenuServices : IInsideOrbitMenuServices = new InsideOrbitMenuService(launcherToOrbitProxyService, locationService, storage);

        ReactDOM.render(
            <ThemeProvider theme = {theme}>
                <InsideOrbitMenuComponent isMobileNotTablet = {isMobileNotTablet} services = {insideOrbitMenuServices}/>
            </ThemeProvider>, container);
        container.style.display = "block";
        clearInterval(shouldRenderInsideOrbitMenuPeriodicCheck);
    }
};

let showInsideMenu = true;
const logger = new ConsoleLoggerService(true);
const storage = new StorageService(logger);
const locationService = new LocationService(window, storage);

if(isLauncherPath(window.location.pathname)) {
    startLauncher(locationService, storage, logger);
} else {

    if(locationService.currentUri.queryParams.getParamValue("hideInsideMenu")){
        showInsideMenu = false;
        //clean up uri by removing ?hideInsideMenu=true from it(without changing path)
        locationService.replace(locationService.currentUri.getUrlWithoutSearchAndHash());
    }

    startOrbit();

    if (showInsideMenu){
        let shouldRenderInsideOrbitMenuPeriodicCheck =  setInterval(() => renderInsideOrbitMenu(shouldRenderInsideOrbitMenuPeriodicCheck), 100);
    }
}
